import { render, staticRenderFns } from "./OrderMsgDetail.vue?vue&type=template&id=4925fdc3&scoped=true&"
import script from "./OrderMsgDetail.vue?vue&type=script&lang=js&"
export * from "./OrderMsgDetail.vue?vue&type=script&lang=js&"
import style0 from "./OrderMsgDetail.vue?vue&type=style&index=0&id=4925fdc3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4925fdc3",
  null
  
)

export default component.exports